import { z } from 'zod';

export const ReceiveCouponServiceRequestSchema = z
  .object({
    shopTitle: z.string(),
    couponNo: z.number().int(),
  })
  .describe('ReceiveCouponServiceRequest');

export type ReceiveCouponServiceRequest = z.infer<typeof ReceiveCouponServiceRequestSchema>;

export const ReceiveCouponServiceResponseSchema = z
  .object({
    couponNo: z.number().int(),
  })
  .describe('ReceiveCouponServiceResponse');

export type ReceiveCouponServiceResponse = z.infer<typeof ReceiveCouponServiceResponseSchema>;
